export default __webpack_public_path__ + "static/media/roboto-v27-latin-italic.d52a565a.woff2";